<div class="locked-tooltip-content">
  <p class="locked-tooltip-message" *ngIf="allowedModules?.length; else semModulo">
    Acesso restrito para {{ isPlural ? 'os módulos' : 'o módulo' }}: <strong>{{ modulesText }}</strong
    >.
  </p>
  <!-- Funcionalidade que nenhum módulo habilita: não há módulo a sugerir. -->
  <ng-template #semModulo>
    <p class="locked-tooltip-message">Funcionalidade não disponível para os módulos contratados.</p>
  </ng-template>
  <p class="locked-tooltip-action">
    <button
      pButton
      type="button"
      label="Fale conosco"
      icon="pi pi-external-link"
      class="p-button-link p-button-sm locked-tooltip-button"
      (click)="openContact()"
    ></button>
  </p>
</div>
